import { Box, Flex } from '@chakra-ui/react';
import React, { Fragment } from 'react';

import useIsLandScapeMachine from '@/hook/useIsLandScapeMachine';

import GameSelector from '../../components/GameComponents/GameSelector/GameSelector';
import GameTypeSelector from '../../components/GameComponents/GameTypeSelector/GameTypeSelector';
import PlatformSelectorRight from '../../components/GameComponents/PlatformSelector/PlatformSelectorRight';
import useDeviceType from '../../hook/useDeviceType';

const GamePlatformPage = () => {
  const isLandscapeMobile = useIsLandScapeMachine();

  const isMobile = useDeviceType() === 'Mobile';
  const isTablet = useDeviceType() === 'Tablet';

  return (
    <Fragment>
      <Flex
        flex={1}
        h={{
          base: 'auto',
          md: 'calc(100%)'
        }}
        maxH={{
          base: 'unset'
          // md: 'calc(100dvh - 125px)'
        }}
        direction={{
          base: 'column'
        }}
      >
        <Box
          position="sticky"
          top={{
            base: '55px',
            md: isLandscapeMobile ? '0' : '100px',
            xl: '125px'
          }}
          left="0px"
          mb={{
            base: '10px',
            md: 'unset'
          }}
          zIndex={1}
        >
          <PlatformSelectorRight />
        </Box>
        <Flex flex={1}>
          <Box
            py={{
              // md: "home-space",
              base: '0'
            }}
            display={{
              base: 'block',
              sm: 'none'
            }}
            // pl="common-y"
            pr="5px"
          >
            <GameTypeSelector />
          </Box>

          <Flex
            gap={{
              base: '0',
              md: '10px'
            }}
            py={{
              base: '0',
              md: 'home-space'
            }}
            px="common-y"
            mb={{
              base: '60px',
              sm: '0px'
            }}
            w={{
              base: '100%'
            }}
            flexDirection={{
              base: 'column',
              md: 'column'
            }}
            flex={1}
            align={'center'}
          >
            {' '}
            <Box
              flex={1}
              h="100%"
              w="100%"
              maxW={{
                md: isLandscapeMobile ? '100dvw' : 'calc(100dvw - 220px)'
              }}
              pb={{
                sm: '110px'
              }}
              overflowX="scroll"
            >
              <GameSelector hiddenTitle topLayout={!isMobile && !isTablet} />
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Fragment>
  );
};

export default GamePlatformPage;
